<template>
	<section>
		<div class="panel-wrapper">
			<div class="filters-section">
				<div class="container">
					<div class="row">
						<div class="col-xs-12 col-md-6 col-lg-3">
							<div class="form-group m-b-sm">
								<label for="inputDateStart">Start Date <span class="input-kbd-help text-gray-5 nano">(YYYY-MM-DD)</span></label>
								<div class="date-nav" >
									<button class="btn btn-input datepicker-trigger" tabindex="-1">
										<span class="flex-container">
											<span class="btn-icon-text">{{ currentStartDateDisplay }}</span><span class="ico-calendar"></span>
										</span>
									</button>
									<DatePicker id="inputDateStart" type="text" @dp-hide="updateStartDate" v-model="currentStartDate" :config="datepickerOptions"></DatePicker>
								</div>
							</div>
						</div>
						<div class="col-xs-12 col-md-6 col-lg-3">
							<div class="form-group m-b-sm">
								<label for="inputDateEnd">End Date <span class="input-kbd-help text-gray-5 nano">(YYYY-MM-DD)</span></label>
								<div class="date-nav" >
									<button class="btn btn-input datepicker-trigger" tabindex="-1">
										<span class="flex-container">
											<span class="btn-icon-text">{{ currentEndDateDisplay }}</span><span class="ico-calendar"></span>
										</span>
									</button>
									<DatePicker id="inputDateEnd" type="text" @dp-hide="updateEndDate" v-model="currentEndDate" :config="datepickerOptions"></DatePicker>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div>
			SELECTED STARTDATE:<br />
			<pre>{{ currentStartDate }}</pre>
		</div>
		<div>
			SELECTED ENDDATE:<br />
			<pre>{{ currentEndDate }}</pre>
		</div>
	</section>
</template>

<script>
import { defineComponent } from 'vue';
import { baseComponentMixin } from '@/mixins/baseComponent.mixin';
import { momentProvider } from '@/services/clock.service';
import moment from 'moment';
import DatePicker from 'vue-bootstrap-datetimepicker';

export default defineComponent({
	name: 'DatePickerTestComponent',
	components: {
		DatePicker
	},
	mixins: {
		baseComponentMixin
	},
	config: {
		key: 'schreg.testDatePicker',
		devPath: 'datepicker-test',
		exported: false
	},
	data() {
		return {
			currentStartDate: momentProvider().format('YYYY-MM-DD'),
			currentEndDate: momentProvider().add(30, 'days').format('YYYY-MM-DD'),
			datepickerType: 'text',
			datepickerOptions: {
				format: 'YYYY-MM-DD',
				widgetPositioning: {
					horizontal: 'left',
					vertical: 'bottom'
				},
				minDate: momentProvider().subtract(7, 'days').format('YYYY-MM-DD'),
				maxDate: momentProvider().add(270, 'days').format('YYYY-MM-DD'),
				ignoreReadonly: true
			}
		};
	},
	computed: {
		currentStartDateDisplay: function() {
			return moment(this.currentStartDate, 'YYYY-MM-DD').format('dddd, MMM D');
		},
		currentEndDateDisplay: function() {
			return moment(this.currentEndDate, 'YYYY-MM-DD').format('dddd, MMM D');
		}
	},
	mounted() {
	},
	methods: {
		completeMounting() {},
		// component methods
		updateStartDate() {
			// If "start" date is changed to after "end" date, also move "end" date
			if (moment(this.currentStartDate, 'YYYY-MM-DD').isAfter(moment(this.currentEndDate, 'YYYY-MM-DD'))) {
				this.currentEndDate = this.currentStartDate;
			}
		},
		updateEndDate() {
			// If "end" date is changed to before "start" date, also move "start" date
			if (moment(this.currentEndDate, 'YYYY-MM-DD').isBefore(moment(this.currentStartDate, 'YYYY-MM-DD'))) {
				this.currentStartDate = this.currentEndDate;
			}
		}
	}
});
</script>

<style lang="scss"> // TODO: Add "scoped" attribute back (with "::v-deep" on rules as necessary)
.date-nav  {
	position: relative;

	.datepicker-trigger {
		transition: none;
	}

	.form-control {
		position: absolute;
		top: 0; left: 0; right: 0; bottom: 0;
		opacity: 0;
		cursor: default;
		-webkit-appearance: none;
  		-moz-appearance: none;

  		&[disabled] {
			cursor: not-allowed;
		}

		html[data-whatintent="keyboard"] &:focus {
			opacity: 1;
		}
	}
}

.input-kbd-help {
	opacity: 0;
	transition: opacity 0.2s;
}

html[data-whatintent="keyboard"] .form-group:focus-within .input-kbd-help {
	opacity: 1;
}

.bootstrap-datetimepicker-widget {
	border-radius: 4px;

	.datepicker-hide + & {
		display: none !important;
	}

	.list-unstyled {
		margin-bottom: 0;
	}

	&.dropdown-menu {
		background-color: $white; // Override regular .dropdown-menu
		color: $gray-darker;
		font-size: 0.813rem; // 13px
		line-height: 1.53846154; // 20px
		z-index: $zindex-tooltip-modal;
		transform: none; // Override regular .dropdown-menu
		border: 1px solid $gray-8;
		margin: 2px 0 0;
		top: 0;
		left: 0;
		padding: 4px;

		// Dropdown pointer/arrow
		&::before,
		&::after {
			content: '';
			display: inline-block;
			border-top: 0;
			position: absolute;
		}

		&::before {
			border-left: 7px solid transparent;
			border-right: 7px solid transparent;
			border-bottom: 7px solid $gray-8;
			left: 6px;
		}

		&::after {
			border-left: 6px solid transparent;
			border-right: 6px solid transparent;
			border-bottom: 6px solid $white;
			left: 7px;
		}

		&.right::before { right: 6px; }
		&.right::after { right: 7px; }
		&.bottom::before { top: -7px; }
		&.bottom::after { top: -5.5858px; }

		&.top::before {
			bottom: -7px;
			border-bottom: 0;
			border-top: 7px solid $gray-8;
		}

		&.top::after {
			bottom: -5.5858px;
			border-bottom: 0;
			border-top: 6px solid $white;
		}
	}

	.datepicker th.picker-switch {
		width: 145px;
		cursor: pointer;

		&:hover {
			background: $gray-11;
			color: $aqua-dark;
		}

		&:active {
			background: $gray-10;
			color: $aqua-darker;
		}
	}

	// TODO: Override shared styles from hiding the datepicker content
	.datepicker-days {
		display: block;
	}
}
</style>
